module.exports = __webpack_public_path__ + "media/assets/img/login-c8a507cfdf0701f0a93e0a6852359a90.jpeg";